import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) {
      // Mostrar banner tras un breve delay para no bloquear la carga
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookiesAccepted', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <p>
            Utilizamos cookies propias y tecnologías similares para mejorar tu experiencia de
            navegación y recordar tus preferencias. Puedes obtener más información en nuestra{' '}
            <Link to="/cookies" className="cookie-banner-link">Política de Cookies</Link>.
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button className="cookie-btn cookie-btn-reject" onClick={handleReject}>
            Rechazar
          </button>
          <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
